<template>
  <div v-if="biddingInfo">
    <div class="estimate-check-section">
      <div class="l-center">
        <p
          class="total-price f-normal mb-7"
          style="color: #f2f4fb; margin-left: 10px"
        >
          견적번호:
          <span style="font-weight: bold">{{ biddingInfo?.bda_no }}</span>
        </p>
        <ul class="est-check-wrap flex">
          <!-- TODO: 클릭 시 is-active가 붙음 -->
          <li
            class="est-check-card"
            :class="{ 'is-active': publicTab === 1 }"
            @click="publicTab = 1"
          >
            <div style="padding-bottom: 4px; text-align: center">
              <div
                class="gap-3"
                style="display: flex; align-items: center; padding-bottom: 4px"
              >
                <i class="icon icon-check-block" />
                <p class="check-tt">공시지원금</p>
              </div>
              <p class="amount-tt" style="font-weight: bold">총 할인 금액</p>
            </div>
            <div class="support-amount-row">
              <p class="label-ttt">공시지원금</p>
              <p class="amount-ttt">
                <span>{{
                  Number(
                    biddingInfo?.bda_info?.dealer_ps_price ??
                      biddingInfo?.ps_price ??
                      0,
                  ).toLocaleString()
                }}</span
                >원
              </p>
            </div>
            <div class="support-amount-row">
              <p class="label-ttt">매장지원금</p>
              <p class="amount-ttt">
                <span>{{
                  Number(
                    biddingInfo?.bda_info?.dealer_model_subsidy ?? 0,
                  ).toLocaleString()
                }}</span
                >원
              </p>
            </div>
          </li>
          <li
            class="est-check-card type-green"
            :class="{ 'is-active': publicTab === 2 }"
            @click="publicTab = 2"
          >
            <div style="padding-bottom: 4px; text-align: center">
              <div
                class="gap-3"
                style="display: flex; align-items: center; padding-bottom: 4px"
              >
                <i class="icon icon-check-block" />
                <p class="check-tt">선택약정</p>
              </div>
              <p class="amount-tt" style="font-weight: bold">총 할인 금액</p>
            </div>
            <div class="support-amount-row">
              <p class="label-ttt">요금할인</p>
              <p class="amount-ttt">
                <span>{{
                  (
                    totalDiscount -
                    (biddingInfo?.bda_info?.dealer_plans_subsidy ?? 0)
                  ).toLocaleString()
                }}</span
                >원
              </p>
            </div>
            <div class="support-amount-row">
              <p class="label-ttt">매장지원금</p>
              <p class="amount-ttt">
                <span>{{
                  Number(
                    biddingInfo?.bda_info?.dealer_plans_subsidy ?? 0,
                  ).toLocaleString()
                }}</span
                >원
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="st-check-conts-wrap">
      <div
        v-if="publicTab === 1"
        :key="1"
        class="estimate-view-section type-check"
      >
        <div class="l-center">
          <div class="estimate-options-wrap pt-46">
            <div class="estimate-payment-wrap flex items-c justify-b">
              <p class="f-wh f-normal f-b">실 구매가</p>
              <p class="f-wh f-rem15 f-r">
                <span class="f-rem20 f-b">{{
                  Number(
                    (biddingInfo.pm_released_price ?? 0) -
                      ((biddingInfo?.bda_info?.dealer_ps_price ??
                        biddingInfo?.ps_price ??
                        0) + biddingInfo?.bda_info?.dealer_model_subsidy ?? 0),
                  ).toLocaleString()
                }}</span
                >원
              </p>
            </div>

            <div class="payment-info-wrap" :class="{ 'is-active': isToggleA1 }">
              <div
                class="payment-info-ttl-wrap"
                @click="isToggleA1 = !isToggleA1"
              >
                <p v-if="!isToggleA1" class="mb-7 f-rem14 f-AEAEAE f-m">
                  월
                  <span>{{ installment.monthlyPayment.toLocaleString() }}</span
                  >원
                </p>
                <p v-else class="mb-7 f-rem14 f-AEAEAE f-m">단말기 정보</p>
                <div class="flex items-c justify-b">
                  <p class="f-normal f-bk f-b">
                    {{ biddingInfo?.bd_info?.phone_model }}
                  </p>
                  <i class="icon icon-arrow-bl" />
                </div>
              </div>
              <ul class="table-cont-wrap type-check-table">
                <li class="table-info flex items-c type-check">
                  <div class="txt-grp">
                    <p class="f-rem14 f-m f-BFC6D4 mb-5">
                      {{
                        selectedInstallmentPeriod === 0
                          ? "기기 원금"
                          : "월 할부금"
                      }}
                    </p>
                    <div class="table-mid-grp flex items-c">
                      <p class="total-price f-normal f-b">
                        {{ selectedInstallmentPeriod === 0 ? "" : "월" }}
                        <span>{{
                          installment.monthlyPayment.toLocaleString()
                        }}</span
                        >원
                      </p>
                      <div
                        v-for="item in installmentPeriodList"
                        :key="item.value"
                        :class="
                          selectedInstallmentPeriod === item.value
                            ? 'month-box f-wh bg-primary ml-8'
                            : 'month-box f-B5B9CB bg-gry ml-6'
                        "
                        style="cursor: pointer"
                        @click="selectedInstallmentPeriod = item.value"
                      >
                        <span>{{ item.text }}</span>
                      </div>

                      <!--                      <select-->
                      <!--                        v-model="selectedInstallmentPeriod"-->
                      <!--                        class="inp select-02 select-month"-->
                      <!--                      >-->
                      <!--                        <option-->
                      <!--                          v-for="item in installmentPeriodList"-->
                      <!--                          :key="item.value"-->
                      <!--                          :value="item.value"-->
                      <!--                        >-->
                      <!--                          {{ item.text }}-->
                      <!--                        </option>-->
                      <!--                      </select>-->
                    </div>
                  </div>
                </li>
                <li class="table-list">
                  <p class="table-tt">출고가</p>
                  <p class="table-cont">
                    {{
                      Number(biddingInfo?.pm_released_price).toLocaleString()
                    }}원
                  </p>
                </li>
                <li class="table-list">
                  <p class="table-tt">공시지원금</p>
                  <p class="table-cont">
                    {{
                      Number(
                        biddingInfo?.bda_info?.dealer_ps_price ??
                          biddingInfo?.ps_price ??
                          0,
                      ).toLocaleString()
                    }}원
                  </p>
                </li>
                <li class="table-list">
                  <p class="table-tt">매장지원금</p>
                  <p class="table-cont">
                    {{
                      Number(
                        biddingInfo?.bda_info?.dealer_model_subsidy,
                      ).toLocaleString()
                    }}원
                  </p>
                </li>
                <li class="table-list">
                  <p class="table-tt">
                    <span v-if="selectedInstallmentPeriod === 0">기기원금</span>
                    <span v-else>할부원금</span>
                  </p>
                  <p class="table-cont">
                    <span>
                      {{ installment.installmentAmount.toLocaleString() }}원
                    </span>
                  </p>
                </li>
                <li v-if="selectedInstallmentPeriod" class="table-list">
                  <p class="table-tt">할부이자 (5.9%)</p>
                  <p class="table-cont">
                    {{ installment.totalInterest.toLocaleString() }}원
                  </p>
                </li>
              </ul>
            </div>

            <div
              v-if="dealerPricePlan"
              class="payment-info-wrap type-phone-plan mb-21"
              :class="{ 'is-active': isToggleA2 }"
            >
              <div
                class="payment-info-ttl-wrap"
                @click="isToggleA2 = !isToggleA2"
              >
                <p v-if="!isToggleA2" class="mb-7 f-rem14 f-AEAEAE f-m">
                  월
                  <span>{{
                    Number(dealerPricePlan?.pp_price).toLocaleString()
                  }}</span
                  >원
                </p>
                <p v-else class="mb-7 f-rem14 f-AEAEAE f-m">요금제 정보</p>
                <div class="flex items-c justify-b">
                  <p class="f-normal f-bk f-b">
                    {{ dealerPricePlan?.pp_carrier }}
                    {{ dealerPricePlan?.pp_name }}
                  </p>
                  <i class="icon icon-arrow-bl" />
                </div>
              </div>
              <ul
                class="table-cont-wrap type-check-table type-phone-plan-table"
              >
                <li class="table-info items-c type-check">
                  <p class="mb-7 f-rem14 f-AEAEAE f-m">월 요금</p>
                  <div class="table-mid-grp flex items-c justify-b">
                    <p class="total-price f-normal f-b">
                      월
                      <span>{{
                        Number(dealerPricePlan?.pp_price).toLocaleString()
                      }}</span
                      >원
                    </p>
                    <div
                      class="month-box f-wh bg-primary ml-8"
                      style="cursor: pointer"
                    >
                      <span>6개월</span>
                    </div>
                  </div>
                </li>
                <li class="table-list">
                  <p class="table-tt">기본요금</p>
                  <p class="table-cont">
                    {{ Number(dealerPricePlan?.pp_price).toLocaleString() }}원
                  </p>
                </li>
                <li>
                  <ul class="plan-benefits-wrap flex items-c justify-c">
                    <li class="plan-benefits-list">
                      <i class="icon icon icon-call" />
                      <p class="plan-benefits-tt f-s">
                        {{ dealerPricePlan?.pp_call_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-mail" />
                      <p class="plan-benefits-tt f-s">
                        {{ dealerPricePlan?.pp_sms_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-wifi" />
                      <p class="plan-benefits-tt f-s">
                        {{ dealerPricePlan?.pp_wifi_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-vdo" />
                      <p class="plan-benefits-tt f-s">
                        {{ dealerPricePlan?.pp_vdo_option || "무제한" }}
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div
              v-if="dealerPricePlan"
              style="text-align: center; margin-bottom: 10px"
            >
              <div class="st-check-conts-wrap">
                <div
                  class="estimate-view-section type-check"
                  style="padding-bottom: 0"
                >
                  <div class="l-center">
                    <div class="estimate-options-wrap pt-46">
                      <div
                        class="estimate-payment-wrap"
                        style="top: 2px; min-height: unset"
                      >
                        <p class="f-wh f-normal f-b">6개월 이후 변경 요금제</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="arrow-container">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4L12 20M12 20L18 14M12 20L6 14"
                    stroke="#2d66fe"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              class="payment-info-wrap type-phone-plan mb-21"
              :class="{ 'is-active': isToggleA3 }"
              :style="{ marginTop: dealerPricePlan ? '0' : '21px' }"
            >
              <div
                class="payment-info-ttl-wrap"
                @click="isToggleA3 = !isToggleA3"
              >
                <p v-if="!isToggleA3" class="mb-7 f-rem14 f-AEAEAE f-m">
                  월
                  <span>{{
                    Number(biddingInfo?.pp_price).toLocaleString()
                  }}</span
                  >원
                </p>
                <p v-else class="mb-7 f-rem14 f-AEAEAE f-m">요금제 정보</p>
                <div class="flex items-c justify-b">
                  <p class="f-normal f-bk f-b">
                    {{ biddingInfo?.bd_info?.phone_plans }}
                  </p>
                  <i class="icon icon-arrow-bl" />
                </div>
              </div>
              <ul
                class="table-cont-wrap type-check-table type-phone-plan-table"
              >
                <li class="table-info items-c type-check">
                  <p class="mb-7 f-rem14 f-AEAEAE f-m">월 요금</p>
                  <div class="table-mid-grp flex items-c justify-b">
                    <p class="total-price f-normal f-b">
                      월
                      <span>{{
                        Number(biddingInfo?.pp_price).toLocaleString()
                      }}</span
                      >원
                    </p>
                    <div
                      class="month-box f-wh bg-primary ml-8"
                      style="cursor: pointer"
                    >
                      <span>{{ dealerPricePlan ? 18 : 24 }}개월</span>
                    </div>
                  </div>
                </li>
                <li class="table-list">
                  <p class="table-tt">기본요금</p>
                  <p class="table-cont">
                    {{ Number(biddingInfo?.pp_price).toLocaleString() }}원
                  </p>
                </li>
                <li>
                  <ul class="plan-benefits-wrap flex items-c justify-c">
                    <li class="plan-benefits-list">
                      <i class="icon icon icon-call" />
                      <p class="plan-benefits-tt f-s">
                        {{ biddingInfo?.pp_call_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-mail" />
                      <p class="plan-benefits-tt f-s">
                        {{ biddingInfo?.pp_sms_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-wifi" />
                      <p class="plan-benefits-tt f-s">
                        {{ biddingInfo?.pp_wifi_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-vdo" />
                      <p class="plan-benefits-tt f-s">
                        {{ biddingInfo?.pp_vdo_option || "무제한" }}
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="publicTab === 2"
        :key="2"
        class="estimate-view-section type-check"
      >
        <div class="l-center">
          <div class="estimate-options-wrap pt-46">
            <div
              class="estimate-payment-wrap flex items-c justify-b type-green"
            >
              <p class="f-wh f-normal f-b">실 구매가</p>
              <p class="f-wh f-rem15 f-r">
                <span class="f-rem20 f-b">{{
                  (
                    (biddingInfo.pm_released_price ?? 0) - totalDiscount
                  ).toLocaleString()
                }}</span
                >원
              </p>
            </div>

            <div
              class="payment-info-wrap type-green"
              :class="{ 'is-active': isToggleB1 }"
            >
              <div
                class="payment-info-ttl-wrap"
                @click="isToggleB1 = !isToggleB1"
              >
                <p v-if="!isToggleB1" class="mb-7 f-rem14 f-AEAEAE f-m">
                  월
                  <span>{{ installment.monthlyPayment.toLocaleString() }}</span
                  >원
                </p>
                <p v-else class="mb-7 f-rem14 f-AEAEAE f-m">단말기 정보</p>

                <div class="flex items-c justify-b">
                  <p class="f-normal f-bk f-b">
                    {{ biddingInfo?.bd_info?.phone_model }}
                  </p>
                  <i class="icon icon-arrow-bl" />
                </div>
              </div>
              <ul class="table-cont-wrap type-check-table">
                <li class="table-info flex items-c type-check type-green">
                  <div class="txt-grp">
                    <p class="f-rem14 f-m f-BFC6D4 mb-5">
                      {{
                        selectedInstallmentPeriod === 0
                          ? "기기 원금"
                          : "월 할부금"
                      }}
                    </p>
                    <div class="table-mid-grp flex items-c">
                      <p class="total-price f-normal f-green f-b">
                        {{ selectedInstallmentPeriod === 0 ? "" : "월" }}
                        <span>{{
                          installment.monthlyPayment.toLocaleString()
                        }}</span
                        >원
                      </p>
                      <div
                        v-for="item in installmentPeriodList"
                        :key="item.value"
                        :class="
                          selectedInstallmentPeriod === item.value
                            ? 'month-box f-wh bg-green ml-8'
                            : 'month-box f-B5B9CB bg-gry ml-6'
                        "
                        style="cursor: pointer"
                        @click="selectedInstallmentPeriod = item.value"
                      >
                        <span>{{ item.text }}</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="table-list">
                  <p class="table-tt">출고가</p>
                  <p class="table-cont">
                    {{
                      Number(biddingInfo?.pm_released_price).toLocaleString()
                    }}원
                  </p>
                </li>
                <li class="table-list">
                  <p class="table-tt">매장지원금</p>
                  <p class="table-cont">
                    {{
                      Number(
                        biddingInfo?.bda_info?.dealer_plans_subsidy,
                      ).toLocaleString()
                    }}원
                  </p>
                </li>
                <li class="table-list">
                  <p v-if="selectedInstallmentPeriod === 0" class="table-tt">
                    기기원금
                  </p>
                  <p v-else class="table-tt">할부원금</p>
                  <p class="table-cont">
                    {{ installment.installmentAmount.toLocaleString() }}원
                  </p>
                </li>
                <li v-if="selectedInstallmentPeriod" class="table-list">
                  <p class="table-tt">할부이자 (5.9%)</p>
                  <p class="table-cont">
                    {{ installment.totalInterest.toLocaleString() }}원
                  </p>
                </li>
              </ul>
            </div>

            <div
              v-if="dealerPricePlan"
              class="payment-info-wrap type-phone-plan mb-21 type-green"
              :class="{ 'is-active': isToggleB2 }"
            >
              <div
                class="payment-info-ttl-wrap"
                @click="isToggleB2 = !isToggleB2"
              >
                <p v-if="!isToggleB2" class="mb-7 f-rem14 f-AEAEAE f-m">
                  월
                  <span>{{
                    Number(
                      Math.round(dealerPricePlan?.pp_price * (1 - 0.25)),
                    ).toLocaleString()
                  }}</span
                  >원
                </p>
                <p v-else class="mb-7 f-rem14 f-AEAEAE f-m">요금제 정보</p>
                <div class="flex items-c justify-b">
                  <p class="f-normal f-bk f-b">
                    {{ dealerPricePlan?.pp_carrier }}
                    {{ dealerPricePlan?.pp_name }}
                  </p>
                  <i class="icon icon-arrow-bl" />
                </div>
              </div>
              <ul
                class="table-cont-wrap type-check-table type-phone-plan-table"
              >
                <li class="items-c type-check type-green">
                  <p class="mb-7 f-rem14 f-AEAEAE f-m">월 요금</p>
                  <div
                    class="table-mid-grp flex items-c justify-b"
                    style="margin-bottom: 24.5px"
                  >
                    <p
                      class="total-price f-normal f-green f-b"
                      style="flex-grow: 1"
                    >
                      월
                      <span>{{
                        Number(
                          Math.round(dealerPricePlan?.pp_price * (1 - 0.25)),
                        ).toLocaleString()
                      }}</span
                      >원
                    </p>
                    <div
                      class="month-box f-wh bg-green ml-8"
                      style="cursor: pointer"
                    >
                      <span>4개월</span>
                    </div>
                  </div>
                </li>
                <li class="table-list">
                  <p class="table-tt">기본요금</p>
                  <p class="table-cont">
                    {{ Number(dealerPricePlan?.pp_price).toLocaleString() }}원
                  </p>
                </li>
                <li class="table-list">
                  <p class="table-tt">선택 약정 할인 (25%)</p>
                  <p class="table-cont">
                    {{
                      Number(
                        Math.round(dealerPricePlan?.pp_price * 0.25),
                      ).toLocaleString()
                    }}원
                  </p>
                </li>
                <li>
                  <ul
                    class="plan-benefits-wrap flex items-c justify-c type-green"
                  >
                    <li class="plan-benefits-list">
                      <i class="icon icon icon-call" />
                      <p class="plan-benefits-tt f-s">
                        {{ dealerPricePlan?.pp_call_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-mail" />
                      <p class="plan-benefits-tt f-s">
                        {{ dealerPricePlan?.pp_sms_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-wifi" />
                      <p class="plan-benefits-tt f-s">
                        {{ dealerPricePlan?.pp_wifi_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-vdo" />
                      <p class="plan-benefits-tt f-s">
                        {{ dealerPricePlan?.pp_vdo_option || "무제한" }}
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div
              v-if="dealerPricePlan"
              style="text-align: center; margin-bottom: 10px"
            >
              <div class="st-check-conts-wrap">
                <div
                  class="estimate-view-section type-check"
                  style="padding-bottom: 0"
                >
                  <div class="l-center">
                    <div class="estimate-options-wrap pt-46">
                      <div
                        class="estimate-payment-wrap type-green"
                        style="top: 2px; min-height: unset"
                      >
                        <p class="f-wh f-normal f-b">4개월 이후 변경 요금제</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="arrow-container">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4L12 20M12 20L18 14M12 20L6 14"
                    stroke="#007b15"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              class="payment-info-wrap type-phone-plan mb-21 type-green"
              :class="{ 'is-active': isToggleB3 }"
              :style="{ marginTop: dealerPricePlan ? '0' : '21px' }"
            >
              <div
                class="payment-info-ttl-wrap"
                @click="isToggleB3 = !isToggleB3"
              >
                <p v-if="!isToggleB3" class="mb-7 f-rem14 f-AEAEAE f-m">
                  월
                  <span>{{
                    Number(
                      Math.round(biddingInfo?.pp_price * (1 - 0.25)),
                    ).toLocaleString()
                  }}</span
                  >원
                </p>
                <p v-else class="mb-7 f-rem14 f-AEAEAE f-m">요금제 정보</p>
                <div class="flex items-c justify-b">
                  <p class="f-normal f-bk f-b">
                    {{ biddingInfo?.bd_info?.phone_plans }}
                  </p>
                  <i class="icon icon-arrow-bl" />
                </div>
              </div>
              <ul
                class="table-cont-wrap type-check-table type-phone-plan-table"
              >
                <li class="items-c type-check type-green">
                  <p class="mb-7 f-rem14 f-AEAEAE f-m">월 요금</p>
                  <div
                    class="table-mid-grp flex items-c justify-b"
                    style="margin-bottom: 24.5px"
                  >
                    <p
                      class="total-price f-normal f-green f-b"
                      style="flex-grow: 1"
                    >
                      월
                      <span>{{
                        Number(
                          Math.round(biddingInfo?.pp_price * (1 - 0.25)),
                        ).toLocaleString()
                      }}</span
                      >원
                    </p>
                    <div
                      class="month-box f-wh bg-green ml-8"
                      style="cursor: pointer"
                    >
                      <span>{{ dealerPricePlan ? 20 : 24 }}개월</span>
                    </div>
                  </div>
                </li>
                <li class="table-list">
                  <p class="table-tt">기본요금</p>
                  <p class="table-cont">
                    {{ Number(biddingInfo?.pp_price).toLocaleString() }}원
                  </p>
                </li>
                <li class="table-list">
                  <p class="table-tt">선택 약정 할인 (25%)</p>
                  <p class="table-cont">
                    {{
                      Number(
                        Math.round(biddingInfo?.pp_price * 0.25),
                      ).toLocaleString()
                    }}원
                  </p>
                </li>
                <li>
                  <ul
                    class="plan-benefits-wrap flex items-c justify-c type-green"
                  >
                    <li class="plan-benefits-list">
                      <i class="icon icon icon-call" />
                      <p class="plan-benefits-tt f-s">
                        {{ biddingInfo?.pp_call_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-mail" />
                      <p class="plan-benefits-tt f-s">
                        {{ biddingInfo?.pp_sms_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-wifi" />
                      <p class="plan-benefits-tt f-s">
                        {{ biddingInfo?.pp_wifi_option || "무제한" }}
                      </p>
                    </li>
                    <li class="plan-benefits-list">
                      <i class="icon icon-vdo" />
                      <p class="plan-benefits-tt f-s">
                        {{ biddingInfo?.pp_vdo_option || "무제한" }}
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, getCurrentInstance, ref } from "vue";
import { InstallmentCalculator } from "@/lib/installmentCalculator";
import { computedAsync } from "@vueuse/core";

const props = defineProps({
  biddingInfo: {
    type: Object,
    required: true,
  },
  publicTabs: {
    type: Number,
    required: false,
    default: 1,
  },
});

const publicTab = ref(props.publicTabs ?? 1);
const isToggleA1 = ref(true);
const isToggleA2 = ref(true);
const isToggleA3 = ref(true);
const isToggleB1 = ref(true);
const isToggleB2 = ref(true);
const isToggleB3 = ref(true);
const installmentPeriodList = [
  { value: 0, text: "일시납" },
  { value: 24, text: "24개월" },
  { value: 36, text: "36개월" },
];
const selectedInstallmentPeriod = ref(24);

const installment = computed(() =>
  InstallmentCalculator.calculateLoan(
    props.biddingInfo?.pm_released_price ?? 0,
    publicTab.value === 1
      ? (props.biddingInfo?.bda_info?.dealer_ps_price ??
          props.biddingInfo?.ps_price ??
          0)
      : 0,
    publicTab.value === 1
      ? (props.biddingInfo?.bda_info?.dealer_model_subsidy ?? 0)
      : (props.biddingInfo?.bda_info?.dealer_plans_subsidy ?? 0),
    selectedInstallmentPeriod.value,
  ),
);

const { proxy } = getCurrentInstance();

const dealerPricePlan = computedAsync(async () => {
  if (!props.biddingInfo?.bd_info) {
    return;
  }
  const _params = {
    tags: [],
    carrier:
      props.biddingInfo?.bd_info?.move_carrier ||
      props.biddingInfo?.bd_info?.curr_carrier,
    cellular_type: "5g" || "4g",
  };
  const { data } = await proxy.axios.get("/api/user/v1/phone-plans", {
    params: _params,
  });

  if (data.query.length === 0) {
    return;
  }
  return data.query.find(
    (v) => v.pp_no === +props.biddingInfo?.bda_info?.dealer_pp_no,
  );
});

const totalDiscount = computed(() => {
  if (dealerPricePlan.value) {
    return (
      (dealerPricePlan.value?.pp_price ?? 0) * 0.25 * 4 +
      (props.biddingInfo?.pp_price ?? 0) * 0.25 * 20 +
      (props.biddingInfo?.bda_info?.dealer_plans_subsidy ?? 0)
    );
  } else {
    return (
      (props.biddingInfo?.pp_price ?? 0) * 0.25 * 24 +
      (props.biddingInfo?.bda_info?.dealer_plans_subsidy ?? 0)
    );
  }
});
</script>
